/* 
 * Export component file to be used on project
*/

import ScheduleContainer from './ScheduleContainer.js';
export default ScheduleContainer;
